export default __webpack_public_path__ + "static/media/cenaidjaxxx-color.87c271ac.svg";